/**
 * Convert the DB answer format (array of single-key objects) to a flat object
 * for react-hook-form defaultValues.
 *
 * Example:
 *   [{ notes: "Looks good" }, { status: "Approve" }]
 *   → { notes: "Looks good", status: "Approve" }
 */
export function answersToFormValues(
  answersJson: Record<string, unknown>[],
): Record<string, unknown> {
  return answersJson.reduce<Record<string, unknown>>(
    (acc, answer) => ({ ...acc, ...answer }),
    {},
  );
}

/**
 * Convert flat form values back for the API.
 *
 * The API controller already converts a flat object into the array-of-objects
 * format when persisting, so we pass the flat object through as-is.
 */
export function formValuesToAnswers(
  values: Record<string, unknown>,
): Record<string, unknown> {
  return values;
}
